import { render, staticRenderFns } from "./FbLikertView.vue?vue&type=template&id=a35533ba"
import script from "./FbLikertView.vue?vue&type=script&lang=js"
export * from "./FbLikertView.vue?vue&type=script&lang=js"
import style0 from "./FbLikertView.vue?vue&type=style&index=0&id=a35533ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports